import { trackRuntimeError, Observable } from '@datadog/browser-core';
import { reportRawError } from '../../reportRawError';
export function startRuntimeErrorCollection(configuration, sender, rawErrorObservable) {
    if (rawErrorObservable === void 0) { rawErrorObservable = new Observable(); }
    if (configuration.forwardErrorsToLogs) {
        trackRuntimeError(rawErrorObservable);
    }
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) { return reportRawError(rawError, sender); });
    return {
        stop: function () {
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map